import {createContext, useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import BaseApi from "../utils/BaseApi";

const AuthContext = createContext({});
export default AuthContext;


export const AuthProvider = ({children}) => {
    
    const navigate = useNavigate();
    
    const [authTokens, setAuthTokens] = useState(() =>
        localStorage.getItem("authTokens")
            ? typeof localStorage.getItem("authTokens") === 'string' ? JSON.parse(localStorage.getItem("authTokens")): localStorage.getItem("authTokens")
            : null
    );
    let [loading, setLoading] = useState(true);

    const api = new BaseApi();
    
    let loginUser = async (useData) => {
        let response = await api.post('auth/token/', useData);
        if (response.status === 200) {
            setAuthTokens(response.data);
            localStorage.setItem('authTokens', JSON.stringify(response.data));
            const urlParams = new URLSearchParams(window.location.search);
            const next = urlParams.get('next');
            if (next){
                navigate(next)
            }
            else {
                navigate("/");
            }
        } else if (response.status === 500) {
            localStorage.removeItem('authTokens');
            console.log("Неполадки на сервере");
        } else if (response.status === 401) {
            localStorage.removeItem('authTokens');
            console.log("введен неккоректное имя пользователя или пароль");
        } else {
            localStorage.removeItem('authTokens');
            console.log(response.status);
        }
        return response;
    };
    let logout = async (e) => {
        localStorage.removeItem('authTokens');
        navigate('/login');
    };
    const changePassword = (data) => {
        const api = new BaseApi();
        let response = api.post(
            'users/reset_password_confirm/',
            data
        );
        return response.data
    };
    let contextData = {
        loginUser: loginUser,
        changePassword: changePassword,
        logout: logout,
    };
    
    useEffect((e) => {
        // if (!authTokens) {
        //     navigate('/login')
        // }
        setLoading(false);
    }, [authTokens, loading]);
    
    return (
        <AuthContext.Provider value={contextData}>
            {
                loading ?
                    <>No auth data</>:
                    children
            }
        </AuthContext.Provider>
    );
};